import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  production: false,
  standaloneTracker: false,
  baseUrl: 'https://atapi2.postnord.com/rest/location/v3/lockedspace',
  baseUrlV2: 'https://atapi2.postnord.com/rest/location/v2/lockedspace',
  apiKey: '********************************',
  prodTrackerUrl: 'https://a79n04qs44.execute-api.eu-west-1.amazonaws.com/prod',
  testTrackerUrl: 'https://i8cvwa03z1.execute-api.eu-west-1.amazonaws.com/test',
  createEdiUrl: 'https://e6agtlat09.execute-api.eu-west-1.amazonaws.com/test/sao/v3/edi',
  instructionUrl: 'https://jbp526nrc9.execute-api.eu-west-1.amazonaws.com/test/instructions',
  instructionApiKey: '****************************************',
  privateKey: '-----PRIVATE KEY-----',
};